import React, { useMemo } from "react";
import { Modal, Spin } from "antd";
import { BillOfLadingType, BillOfLadingMediaPurpose } from "@/utils/enum";
import ImagesGrid from "@/pages/AdminShipments/AdminShipmentView/VehicleImagesModal/ImagesGrid";

const VehicleImagesModal = ({ isOpen, title, images, submitCallback, cancelCallback, isLoading }) => {
  const pickupImages = useMemo(
    () =>
      images
        ?.find(folder => folder.type === BillOfLadingType.Pickup)
        ?.medias?.filter(media => media.purpose !== BillOfLadingMediaPurpose.Signatures) ?? [],
    [images],
  );

  const dropoffImages = useMemo(
    () =>
      images
        ?.find(folder => folder.type === BillOfLadingType.DropOff)
        ?.medias?.filter(media => media.purpose !== BillOfLadingMediaPurpose.Signatures) ?? [],
    [images],
  );

  return (
    <Modal
      title={title}
      open={isOpen}
      onOk={() => submitCallback?.()}
      onCancel={() => cancelCallback?.()}
      cancelButtonProps={{ hidden: true }}
    >
      {isLoading ? (
        <Spin />
      ) : (
        <>
          <ImagesGrid title="Pickup" images={pickupImages} />
          <ImagesGrid title="Dropoff" images={dropoffImages} />
        </>
      )}
    </Modal>
  );
};

export default VehicleImagesModal;
